// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"106":"a3fb9a72","608":"f05fccb8","879":"f19ac992"}[chunkId] + ".css";
};